import { useEffect } from "react";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Dashboard from "../Table/dashboard/Dashboard";
import User from "../Table/user/User";
import Setting from "../Table/setting/Setting";
import $ from "jquery";

import UserProfile from "../Table/user/UserProfile";
import Seller from "../Table/seller/Seller";
import AdminProfile from "../Table/admin/AdminProfile";
import SellerRequest from "../Table/sellerRequest/SellerRequest";
import FaithLeaderRequest from "../Table/faithLeader/FaithLeaderRequest";
import FaithLeaderWithdraw from "../Table/faithLeader/FaithLeaderWithdraw";
import FaithQuote from "../Table/faithQuote/FaithQuote";
import StreamingPortal from "./StreamingPortal";
import PopupAds from "../Table/popupAd/PopupAds";
import Website from "./Website";
import ServiceProviderRequest from "../Table/serviceProviderRequest/ServiceProviderRequest";
import ServiceCategoryPage from "../Table/serviceCategory/ServiceCategory";
import SellerProfile from "../Table/seller/SellerProfile";
import AddSeller from "../Table/seller/AddSeller";
import Product from "../Table/Product/Product";
import ProductDetail from "../Table/Product/ProductDetail";
import Category from "../Table/category/Category";
import Slider from "../Table/slider/Slider";
import Showcase from "../Table/showcase/Showcase";
import Gift from "../Table/gift/Gift";
import CoinPackage from "../Table/coinPackage/CoinPackage";
import CoinBonus from "../Table/coinBonus/CoinBonus";
import GiftTransaction from "../Table/giftTransaction/GiftTransaction";
import CashoutRequest from "../Table/cashoutRequest/CashoutRequest";
// import Order from "../Table/Order/Order";
import Order from "../Table/Order/Order";
import OrderDetail from "../Table/Order/OrderDetail";
import PromoCode from "../Table/PromoCode/PromoCode";
import ShippingMethod from "../Table/ShippingMethod/ShippingMethod";
import FaQ from "../Table/FAQ/Faq";
import Withdraw from "../Table/withdraw/Withdraw";
import Attribute from "../Table/Attribute/Attribute";
import Redeem from "../Table/redeem/Redeem";
import CategoryWiseSubCategory from "../Table/subCategory/CategoryWiseSubCategory";
import PendingProduct from "../Table/Product/PendingProduct";
import ApprovedProduct from "../Table/Product/ApprovedProduct";
import RejectedProduct from "../Table/Product/RejectedProduct";
import AddProduct from "../Table/Product/AddProduct";
import PaymentSetting from "../Table/setting/paymentSetting";
import UpdateRequest from "../Table/Product/UpdateRequest";
import UpdateProducutApproved from "../Table/Product/UpdateProducutApproved";
import UpdateProductRejected from "../Table/Product/UpdateProductRejected";
import SellerOrderDetail from "../Table/seller/Profile/SellerOrderDetail";
import LiveSeller from "../Table/liveSeller/LiveSeller";
import LiveSellerProduct from "../Table/liveSeller/LiveSellerProduct";
import LiveHistory from "../Table/liveSeller/LiveHistory";
import Sounds from "../Table/sound/Sounds";
import AdminWallet from "../Table/admin/AdminWallet";
// import EditSellerR from "../Table/sellerRequest/EditSellerR";
import EditSellerRequest from "../Table/sellerRequest/EditSellerRequest";
import FakeSeller from "../Table/fakeSeller/FakeSeller";
import Reels from "../Table/reels/Reels";
import ReelReview from "../Table/reels/ReelReview";
import AdsReview from "../Table/ads/AdsReview";
import BoostsAdmin from "../Table/ads/BoostsAdmin";
import Community from "../Table/community/Community";
import CommunityDetail from "../Table/community/CommunityDetail";
import CommunityReports from "../Table/community/CommunityReports";
import SocialReports from "../Table/social/SocialReports";
import UploadFailures from "../Table/uploadFailure/UploadFailures";
import VideoPlayback from "../Table/videoPlayback/VideoPlayback";
import Challenges from "../Table/community/Challenges";
import FakeReels from "../Table/fakeReels/FakeReels";
import ReelsInfo from "../Table/reels/ReelsInfo";
// import ReportedReels from "../Table/reels/ReportedReels";
import FakeSellerDialogue from "../Table/fakeSeller/FakeSellerDialogue";
import FakeProduct from "../Table/FakeProduct/FakeProduct";
import { useSelector } from "react-redux";
import BankSetting from "../Table/bank/BankSetting";
import CurrencySetting from "../Table/currencySetting/currencySetting";
import ExchangeRateSetting from "../Table/exchangeRate/ExchangeRateSetting";
import AdminEarning from "../Table/admin/AdminEarning";
import AdminWithdrawal from "../Table/AdminWithdrawal/AdminWithdrawal";
import ReportReason from "../Table/reportReason/ReportReason";
import { Video } from "lucide-react";
import VideoReport from "../Table/videoReport/VideoReport";
import Others from "../Table/other/Others";
import Logistics from "../Table/Logistics/Logistics";
import Chat from "../Table/chat/Chat";
import ChatDetails from "../Table/chat/ChatDetails";
import SupportChat from "../Table/supportChat/SupportChat";
import SupportChatDetails from "../Table/supportChat/SupportChatDetails";
import AffiliateRequest from "../Table/affiliateRequest/AffiliateRequest";
import Affiliate from "../Table/affiliate/Affiliate";
import AffiliateWithdraw from "../Table/affiliateWithdraw/AffiliateWithdraw";
import TransactionHistory from "../Table/transaction/TransactionHistory";
import AddCoins from "../Table/addCoins/AddCoins";
import AffiliateReels from "../Table/affiliateReels/AffiliateReels";
import SourcingRequest from "../Table/sourcingRequest/SourcingRequest";
import RewardWallets from "../Table/rewardWallet/RewardWallets";
import RewardTransactions from "../Table/rewardWallet/RewardTransactions";
import EarningRules from "../Table/rewardWallet/EarningRules";
import KycQueue from "../Table/kyc/KycQueue";
import AuditLog from "../Table/auditLog/AuditLog";
import CoinsLeader from "../Table/auditLog/CoinsLeader";
import BlockedAccounts from "../Table/auditLog/BlockedAccounts";
import GiftTransferLogs from "../Table/auditLog/GiftTransferLogs";
import LiveGamesLogs from "../Table/auditLog/LiveGamesLogs";
import Payments from "../Table/auditLog/Payments";
import AdminLogins from "../Table/auditLog/AdminLogins";
import SupportAgents from "../Table/supportAgent/SupportAgents";
import CreatorHires from "../Table/creatorMarket/CreatorHires";

export const token = sessionStorage.getItem("token");

const Admin = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();


  const { isAuth } = useSelector((state) => state.admin);

  useEffect(() => {
    if (
      location.pathname == "/" ||
      location.pathname == "/admin" ||
      location.pathname == "" ||
      location.pathname == "/admin/"
    ) {
      navigate("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    $(document).ready(function () {
      $(".subMenu").hide();

      $(".mainMenu > li > a").click(function () {
        if ($(this).next(".subMenu").is(":visible")) {
          // If it's open, close it
          $(this).next(".subMenu").slideUp();
          $(this).children("i").removeClass("rotate90");
        } else {
          // If it's closed, close all other submenus and open the clicked one
          $(".subMenu").slideUp();
          $(".mainMenu > li > a").children("i").removeClass("rotate90");
          $(this).next(".subMenu").slideDown();
          $(this).children("i").addClass("rotate90");
        }
      });

      $(".navToggle").click(function () {
        $(".mainNavbar").toggleClass("mobNav webNav");
        $(".sideBar").toggleClass("mobSidebar webSidebar");
        $(".mainAdmin").toggleClass("mobAdmin");
      });
    });
  }, []);

  return (
    <>
      <div className="mainContainer d-flex w-100">
        <div className="containerLeft">
          <Sidebar />
        </div>
        <div className="containerRight w-100">
          <Navbar />
          <div className="mainAdmin">
            <Routes>
              {/* dashboard */}
              <Route path="/dashboard" element={<Dashboard />} />

              {/* user */}

              <Route path="/user" element={<User />} />
              <Route path="/UserProfile" element={<UserProfile />} />
              <Route
                path="/sellerRequestEdit"
                element={<EditSellerRequest />}
              />

              {/* seller */}
              <Route path="/seller" element={<Seller />} />
              <Route path="/fakeSeller" element={<FakeSeller />} />
              <Route path="/addFakeSeller" element={<FakeSellerDialogue />} />
              <Route path="/liveSeller" element={<LiveSeller />} />
              <Route path="/liveHistory" element={<LiveHistory />} />
              <Route path="/sounds" element={<Sounds />} />
              <Route
                path="/liveSellerProduct"
                element={<LiveSellerProduct />}
              />
              <Route path="/sellerProfile" element={<SellerProfile />} />
              <Route path="/addSeller" element={<AddSeller />} />
              <Route
                path="/sellerOrderDetail"
                element={<SellerOrderDetail />}
              />
              {/* seller Request */}
              <Route path="/sellerRequest" element={<SellerRequest />} />
              <Route path="/faithLeaderRequest" element={<FaithLeaderRequest />} />
              <Route path="/faithLeaderWithdraw" element={<FaithLeaderWithdraw />} />
              <Route path="/faithQuotes" element={<FaithQuote />} />
              <Route path="/streamingPortal" element={<StreamingPortal />} />
              <Route path="/popupAds" element={<PopupAds />} />
              <Route path="/website" element={<Website />} />
              <Route path="/serviceProviderRequest" element={<ServiceProviderRequest />} />
              <Route path="/serviceCategory" element={<ServiceCategoryPage />} />

              {/* affiliate */}
              <Route path="/affiliateRequest" element={<AffiliateRequest />} />
              <Route path="/affiliate" element={<Affiliate />} />

              {/* category  && subCategory */}
              <Route path="/category" element={<Category />} />
              <Route
                path="/category/subCategory"
                element={<CategoryWiseSubCategory />}
              />

              {/* slider */}
              <Route path="/slider" element={<Slider />} />

              {/* showcase */}
              <Route path="/showcase" element={<Showcase />} />

              {/* gifting system */}
              <Route path="/gift" element={<Gift />} />
              <Route path="/coinPackage" element={<CoinPackage />} />
              <Route path="/coinBonus" element={<CoinBonus />} />
              <Route path="/addCoins" element={<AddCoins />} />
              <Route path="/giftTransaction" element={<GiftTransaction />} />
              <Route path="/cashoutRequest" element={<CashoutRequest />} />

              {/* attributes */}
              <Route path="/attribute" element={<Attribute />} />

              {/* Product */}
              <Route path="/product" element={<Product />} />
              <Route path="/addProduct" element={<AddProduct />} />
              <Route path="/fake/addProduct" element={<AddProduct />} />

              <Route path="/productDetail" element={<ProductDetail />} />
              <Route path="/fake/productDetail" element={<ProductDetail />} />

              {/* Fake Product */}
              <Route path="/fakeProduct" element={<FakeProduct />} />

              {/* video Report */}
              <Route path="/videoreport" element={<VideoReport />} />


              {/* create Product Request by App */}
              <Route path="/pendingProduct" element={<PendingProduct />} />
              <Route path="/approvedProduct" element={<ApprovedProduct />} />
              <Route path="/rejectedProduct" element={<RejectedProduct />} />

              {/* update Product Request by App */}

              <Route path="/pendingUpdateRequest" element={<UpdateRequest />} />
              <Route
                path="/approvedUpdateRequest"
                element={<UpdateProducutApproved />}
              />
              <Route
                path="/rejectedUpdateRequest"
                element={<UpdateProductRejected />}
              />

              {/* order */}
              <Route path="/order" element={<Order />} />
              <Route path="/order/orderDetail" element={<OrderDetail />} />

              {/* logistics */}
              <Route path="/logistics" element={<Logistics />} />

              {/* shipping methods */}
              <Route path="/shippingMethod" element={<ShippingMethod />} />

              {/* sourcing requests */}
              <Route path="/sourcingRequest" element={<SourcingRequest />} />

              {/* audit logs */}
              <Route path="/coinsLogs" element={<AuditLog />} />
              <Route path="/coinsLeader" element={<CoinsLeader />} />
              <Route path="/giftTransferLogs" element={<GiftTransferLogs />} />
              <Route path="/liveGames" element={<LiveGamesLogs />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/adminLogins" element={<AdminLogins />} />
              <Route path="/blockedAccounts" element={<BlockedAccounts />} />

              {/* chat management */}
              <Route path="/chat" element={<Chat />} />
              <Route path="/chatDetails" element={<ChatDetails />} />

              {/* support chat */}
              <Route path="/supportChat" element={<SupportChat />} />
              <Route path="/supportChatDetails" element={<SupportChatDetails />} />
              <Route path="/supportAgents" element={<SupportAgents />} />

              {/* promoCode */}
              <Route path="/promoCode" element={<PromoCode />} />

              {/* FaQ */}
              <Route path="/faq" element={<FaQ />} />

              {/* Withdraw Methods*/}
              <Route path="/withDraw" element={<Withdraw />} />

              {/* Seller Withdraw */}
              {/* <Route path="/redeem" element={<Redeem />} /> */}

              {/* admin Profile */}
              <Route path="/profilePage" element={<AdminProfile />} />
              {/* <Route path="/wallet" element={<AdminWallet />} /> */}
              <Route path="/adminwithdrawal" element={<AdminWithdrawal />} />
              <Route path="/affiliatewithdrawal" element={<AffiliateWithdraw />} />
              <Route path="/wallet" element={<AdminEarning />} />

              {/* setting */}
              <Route path="/setting" element={<Setting />} />
              <Route path="/currencySetting" element={<CurrencySetting />} />
            <Route path="/exchangeRates" element={<ExchangeRateSetting />} />
              <Route path="/paymentSetting" element={<PaymentSetting />} />
              <Route path="/bankSetting" element={<BankSetting />} />
              <Route path="/reportreason" element={<ReportReason />} />
              <Route path="/others" element={<Others />} />

              {/* reels */}

              <Route path="/reels" element={<Reels />} />
              <Route path="/reelReview" element={<ReelReview />} />
              <Route path="/ads" element={<AdsReview />} />
              <Route path="/boosts" element={<BoostsAdmin />} />
              <Route path="/creatorHires" element={<CreatorHires />} />
              <Route path="/community" element={<Community />} />
              <Route path="/challenges" element={<Challenges />} />
              <Route path="/community/:id" element={<CommunityDetail />} />
              <Route path="/communityReports" element={<CommunityReports />} />
              <Route path="/socialReports" element={<SocialReports />} />
              <Route path="/uploadFailures" element={<UploadFailures />} />
              <Route path="/videoPlayback" element={<VideoPlayback />} />
              {/* <Route path="/reportedReels" element={<ReportedReels />} /> */}

              <Route path="/real/reels/details" element={<ReelsInfo />} />

              <Route path="/fake/reels/details" element={<ReelsInfo />} />


              {/* fake reels */}

              <Route path="/fakeReels" element={<FakeReels />} />

              {/* affiliate reels */}
              <Route path="/affiliateReels" element={<AffiliateReels />} />

              {/* Transaction History */}
              <Route path="/transactions" element={<TransactionHistory />} />

              {/* Coins / Reward Wallet system */}
              <Route path="/rewardWallets" element={<RewardWallets />} />
              <Route path="/rewardTransactions" element={<RewardTransactions />} />
              <Route path="/earningRules" element={<EarningRules />} />
              <Route path="/kyc" element={<KycQueue />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
